import {
  unregisterSpecificNotificationHandler,
  registerSpecificNotificationHandler,
} from '../../bridge';

/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * network.onNetworkStateChanged
 *
 * [PLATFORM]
 * mac        6.0.5+
 * windows    6.0.5+
 * linux      6.0.5+
 * ios        NotSupport
 * android    NotSupport
 *
 * -------------------------------------------------- API Doc --------------------------------------------------*/
export function onNetworkStateChanged(
  networkStateChangedCallback: (networkState: NetworkState) => void
) {
  registerSpecificNotificationHandler(
    'UnifyNotif_OnNetworkStateChanged',
    networkStateChangedCallback
  );
}

/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * network.offNetworkStateChanged
 *
 * [PLATFORM]
 * mac        6.0.5+
 * windows    6.0.5+
 * linux      6.0.5+
 * ios        NotSupport
 * android    NotSupport
 *
 * -------------------------------------------------- API Doc --------------------------------------------------*/
export function offNetworkStateChanged(
  networkStateChangedCallback: (networkState: NetworkState) => void
) {
  unregisterSpecificNotificationHandler(
    'UnifyNotif_OnNetworkStateChanged',
    networkStateChangedCallback
  );
}

type NetworkState = 'online' | 'offline';

export default {
  onNetworkStateChanged,
  offNetworkStateChanged,
};
